module.exports = __webpack_public_path__ + "static/apple-touch-icon.png";


//////////////////
// WEBPACK FOOTER
// ./src/examples/shared/favicon/apple-touch-icon.png
// module id = 510
// module chunks = 0